import { Component, Host, h, Prop } from '@stencil/core';
import * as lottiePlayer from '@lottiefiles/lottie-player';
import { loaderJson } from './sew-loader.json';

@Component({
    tag: 'sew-loader',
    styleUrl: 'sew-loader.scss',
    shadow: true,
})
export class SewLoader {
    @Prop() text: string;

    render() {
        console.log(lottiePlayer);
        return (
            <Host>
                <div class="grid">
                    <div class="box">
                        <div class="content">
                            <div class="player">
                                <lottie-player autoplay loop mode="normal" src={loaderJson}></lottie-player>
                            </div>
                            <p>{this.text}</p>
                        </div>
                    </div>
                </div>
            </Host>
        );
    }
}
